import { render, staticRenderFns } from "./MateStock.vue?vue&type=template&id=46098f49&scoped=true"
import script from "./MateStock.vue?vue&type=script&lang=js"
export * from "./MateStock.vue?vue&type=script&lang=js"
import style0 from "./MateStock.vue?vue&type=style&index=0&id=46098f49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46098f49",
  null
  
)

export default component.exports